import {
  DataSourceContext,
  IDataSourceContext,
} from "@via/context/data-source-context.tsx";
import { useContext } from "react";

export function useDataSource(): IDataSourceContext {
  return useContext(DataSourceContext);
}
